<div [ngClass]="{'is-bandeau': hasBackground }" class="page-header">
  <div class="page_header-left">
    @if (boutonRetourVisible) {
      <div
        (click)="returnAction()"
        [ngClass]="boutonRetourSansFondBlanc ? 'page_header-retour-sans-fond' : 'button-white-icon'">
        <i class="icon icon-arrow-left"></i>
      </div>
    }
    <h2 class="page_header-title">
      {{titre}}
    </h2>
  </div>
  <div class="page_header-right">
    <ng-content></ng-content>
  </div>
</div>
